import { Filter } from '.';

export interface Conditional {
	filter(data: any, input: Filter): Array<any>;
}
